var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { "min-height": "500", "max-height": "600" } },
    [
      _c(
        "v-tabs",
        {
          attrs: {
            grow: "",
            centered: "",
            "show-arrows": "",
            "background-color": "primary",
            dark: "",
          },
          on: { change: _vm.getDataFromApi },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c("v-tab", { attrs: { href: "#tab-1" } }, [_vm._v(" 1. DÖNEM")]),
          _c("v-tab", { attrs: { href: "#tab-2" } }, [_vm._v(" 2. DÖNEM")]),
        ],
        1
      ),
      _c(
        "v-tabs-items",
        {
          attrs: { touchless: "" },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c(
            "v-tab-item",
            { attrs: { value: "tab-1" } },
            [
              _vm.rows.length > 0
                ? _c(
                    "v-row",
                    _vm._l(_vm.rows, function (item) {
                      return _c(
                        "v-col",
                        {
                          key: item.Id,
                          staticClass: "py-0",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "v-sheet",
                            { attrs: { outlined: "" } },
                            [
                              _c(
                                "v-card",
                                { attrs: { flat: "" } },
                                [
                                  _c(
                                    "v-card-title",
                                    {
                                      class: _vm.$vuetify.breakpoint.mobile
                                        ? "justify-center pb-2"
                                        : "",
                                    },
                                    [_vm._v(_vm._s(item.LessonName))]
                                  ),
                                  _c(
                                    "v-card-text",
                                    [
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              class: _vm.$vuetify.breakpoint
                                                .mobile
                                                ? "d-flex justify-content-between align-items-center"
                                                : "",
                                              attrs: { cols: "12" },
                                            },
                                            [
                                              _c("strong", [
                                                _vm._v(" Yazılılar "),
                                              ]),
                                              _c("div", [
                                                _c("span", [
                                                  _vm._v(
                                                    "1. " +
                                                      _vm._s(
                                                        item.WrittenExam1 !=
                                                          null
                                                          ? item.WrittenExam1
                                                          : "Not girilmedi"
                                                      )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("br"),
                                                _c("span", [
                                                  _vm._v(
                                                    " 2. " +
                                                      _vm._s(
                                                        item.WrittenExam2 !=
                                                          null
                                                          ? item.WrittenExam2
                                                          : "Not girilmedi"
                                                      )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("br"),
                                                _c("span", [
                                                  _vm._v(
                                                    "3. " +
                                                      _vm._s(
                                                        item.WrittenExam3 !=
                                                          null
                                                          ? item.WrittenExam3
                                                          : "Not girilmedi"
                                                      )
                                                  ),
                                                ]),
                                              ]),
                                            ]
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              class: _vm.$vuetify.breakpoint
                                                .mobile
                                                ? "d-flex justify-content-between align-items-center"
                                                : "",
                                              attrs: { cols: "12" },
                                            },
                                            [
                                              _c("strong", [
                                                _vm._v(" Sözlüler "),
                                              ]),
                                              _c("div", [
                                                _c("span", [
                                                  _vm._v(
                                                    "1. " +
                                                      _vm._s(
                                                        item.VerbalExam1 != null
                                                          ? item.VerbalExam1
                                                          : "Not girilmedi"
                                                      )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("br"),
                                                _c("span", [
                                                  _vm._v(
                                                    "2. " +
                                                      _vm._s(
                                                        item.VerbalExam2 != null
                                                          ? item.VerbalExam2
                                                          : "Not girilmedi"
                                                      )
                                                  ),
                                                ]),
                                              ]),
                                            ]
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              class: _vm.$vuetify.breakpoint
                                                .mobile
                                                ? "d-flex justify-content-between align-items-center"
                                                : "",
                                              attrs: { cols: "12" },
                                            },
                                            [
                                              _c("strong", [
                                                _vm._v(" KKS Sonuç "),
                                              ]),
                                              _c("div", [
                                                _c("span", [
                                                  _vm._v(
                                                    "1. " +
                                                      _vm._s(
                                                        item.PerformanceExam1 !=
                                                          null
                                                          ? item.PerformanceExam1
                                                          : "Not girilmedi"
                                                      )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("br"),
                                                _c("span", [
                                                  _vm._v(
                                                    "2. " +
                                                      _vm._s(
                                                        item.PerformanceExam2 !=
                                                          null
                                                          ? item.PerformanceExam2
                                                          : "Not girilmedi"
                                                      )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("br"),
                                                _c("span", [
                                                  _vm._v(
                                                    "3. " +
                                                      _vm._s(
                                                        item.PerformanceExam3 !=
                                                          null
                                                          ? item.PerformanceExam3
                                                          : "Not girilmedi"
                                                      )
                                                  ),
                                                ]),
                                                _c("span", [
                                                  _vm._v(
                                                    "4. " +
                                                      _vm._s(
                                                        item.PerformanceExam4 !=
                                                          null
                                                          ? item.PerformanceExam4
                                                          : "Not girilmedi"
                                                      )
                                                  ),
                                                ]),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "v-tab-item",
            { attrs: { value: "tab-2" } },
            [
              _vm.rows.length > 0
                ? _c(
                    "v-row",
                    _vm._l(_vm.rows, function (item) {
                      return _c(
                        "v-col",
                        {
                          key: item.Id,
                          staticClass: "py-0",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "v-sheet",
                            { attrs: { outlined: "" } },
                            [
                              _c(
                                "v-card",
                                { attrs: { flat: "" } },
                                [
                                  _c(
                                    "v-card-title",
                                    {
                                      class: _vm.$vuetify.breakpoint.mobile
                                        ? "justify-center pb-2"
                                        : "",
                                    },
                                    [_vm._v(_vm._s(item.LessonName))]
                                  ),
                                  _c(
                                    "v-card-text",
                                    [
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              class: _vm.$vuetify.breakpoint
                                                .mobile
                                                ? "d-flex justify-content-between align-items-center"
                                                : "",
                                              attrs: { cols: "12" },
                                            },
                                            [
                                              _c("strong", [
                                                _vm._v(" Yazılılar "),
                                              ]),
                                              _c("div", [
                                                _c("span", [
                                                  _vm._v(
                                                    "1. " +
                                                      _vm._s(
                                                        item.WrittenExam1 !=
                                                          null
                                                          ? item.WrittenExam1
                                                          : "Not girilmedi"
                                                      )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("br"),
                                                _c("span", [
                                                  _vm._v(
                                                    " 2. " +
                                                      _vm._s(
                                                        item.WrittenExam2 !=
                                                          null
                                                          ? item.WrittenExam2
                                                          : "Not girilmedi"
                                                      )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("br"),
                                                _c("span", [
                                                  _vm._v(
                                                    "3. " +
                                                      _vm._s(
                                                        item.WrittenExam3 !=
                                                          null
                                                          ? item.WrittenExam3
                                                          : "Not girilmedi"
                                                      )
                                                  ),
                                                ]),
                                              ]),
                                            ]
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              class: _vm.$vuetify.breakpoint
                                                .mobile
                                                ? "d-flex justify-content-between align-items-center"
                                                : "",
                                              attrs: { cols: "12" },
                                            },
                                            [
                                              _c("strong", [
                                                _vm._v(" Sözlüler "),
                                              ]),
                                              _c("div", [
                                                _c("span", [
                                                  _vm._v(
                                                    "1. " +
                                                      _vm._s(
                                                        item.VerbalExam1 != null
                                                          ? item.VerbalExam1
                                                          : "Not girilmedi"
                                                      )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("br"),
                                                _c("span", [
                                                  _vm._v(
                                                    "2. " +
                                                      _vm._s(
                                                        item.VerbalExam2 != null
                                                          ? item.VerbalExam2
                                                          : "Not girilmedi"
                                                      )
                                                  ),
                                                ]),
                                              ]),
                                            ]
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              class: _vm.$vuetify.breakpoint
                                                .mobile
                                                ? "d-flex justify-content-between align-items-center"
                                                : "",
                                              attrs: { cols: "12" },
                                            },
                                            [
                                              _c("strong", [
                                                _vm._v(" KKS Sonuç "),
                                              ]),
                                              _c("div", [
                                                _c("span", [
                                                  _vm._v(
                                                    "1. " +
                                                      _vm._s(
                                                        item.PerformanceExam1 !=
                                                          null
                                                          ? item.PerformanceExam1
                                                          : "Not girilmedi"
                                                      )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("br"),
                                                _c("span", [
                                                  _vm._v(
                                                    "2. " +
                                                      _vm._s(
                                                        item.PerformanceExam2 !=
                                                          null
                                                          ? item.PerformanceExam2
                                                          : "Not girilmedi"
                                                      )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("br"),
                                                _c("span", [
                                                  _vm._v(
                                                    "3. " +
                                                      _vm._s(
                                                        item.PerformanceExam3 !=
                                                          null
                                                          ? item.PerformanceExam3
                                                          : "Not girilmedi"
                                                      )
                                                  ),
                                                ]),
                                                _c("span", [
                                                  _vm._v(
                                                    "4. " +
                                                      _vm._s(
                                                        item.PerformanceExam4 !=
                                                          null
                                                          ? item.PerformanceExam4
                                                          : "Not girilmedi"
                                                      )
                                                  ),
                                                ]),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }